module.exports = __webpack_public_path__ + "static/media/wingszn-form-header.9a3982bd.webp";